
import { preparePhoneNumber, prepareObjectBeforeSend } from 'src/utils/utils'
import { pick } from 'src/utils/common'

const getDefaultState = () => {
  return {
    form: {
      confirmationNum: '',
      phone_number: '',
      email: ''
    },
    retrieveBy: 'phone_number' // email
    // otpSentTo: ''
  }
}

const state = getDefaultState()

const getters = {
  preparedFormData: state => {
    let { form, retrieveBy } = state
    let data = Object.fromEntries(
      Object.entries(form)
        .filter(([key]) => ['phone_number', 'email'].includes(key))
    )

    data = prepareObjectBeforeSend(data)
    data.phone_number = preparePhoneNumber(data.phone_number)
    data = pick(data, retrieveBy)

    return data
  },
  retrieveByValue: state => {
    let { form, retrieveBy } = state
    let value = form[retrieveBy]
    return value
  }
}

const mutations = {
  RESET_STATE (state) {
    Object.assign(state, getDefaultState())
  },
  SET_FORM_ITEM: (state, { key, value }) => {
    if (state.form.hasOwnProperty(key)) {
      state.form[key] = value
    }
  },
  SET_FORM_DATA: (state, { data }) => {
    state.form = {
      ...state.form,
      ...data
    }
  },
  SET_RETRIEVE_BY: (state, payload) => {
    state.retrieveBy = payload
  },
  NORMALIZE_RETRIEVE_FORM: (state) => {
    let { form, retrieveBy } = state
    let newForm = getDefaultState().form
    newForm[retrieveBy] = form[retrieveBy]
    state.form = {
      ...newForm
    }
  }
}

const actions = {
  resetState ({ commit }) {
    commit('RESET_STATE')
  },
  setFormItem ({ commit }, payload) {
    commit('SET_FORM_ITEM', payload)
  },
  setFormData ({ commit }, payload) {
    commit('SET_FORM_DATA', payload)
  },
  setRetrieveBy ({ commit }, payload) {
    commit('SET_RETRIEVE_BY', payload)
  },
  normalizeRetrieveForm ({ commit }, payload) {
    commit('NORMALIZE_RETRIEVE_FORM', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
